module.exports = __webpack_public_path__ + "static/media/contact-mail.21d483a2.svg";